<template>
  <div>
    <el-row class="title">
      <el-col :span="24" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description flex-title">
            <div class="card-panel-text">汇总信息</div>
        <!--   <el-link style="font-weight:bold;font-size:18px;" @click="toBoard">前往数据看板</el-link>  -->
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0" class="panel-group">
      <el-col :span="isMB?24:12" class="card-panel-col" >   <!--平台用户显示商家总数-->
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <i class="el-icon-sold-out card-panel-icon" />
          </div>
        <!--  <div class="card-panel-description" style="cursor:pointer" @click="toPage('/shop/business')">  -->
           <div class="card-panel-description" >
            <count-to
              :start-val="0"
              :end-val="data.CrossgoodsCount"
              :duration="2000"
              class="card-panel-num"
            />
            <div class="card-panel-text">跨境进口商品</div>
          </div>
        </div>
      </el-col>

      <el-col :span="isMB?24:12" class="card-panel-col" >   <!--平台用户显示店铺总数-->
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <i class="el-icon-shopping-bag-1 card-panel-icon" />
          </div>
          <div class="card-panel-description" >
            <count-to
              :start-val="0"
              :end-val="data.GeneralgoodsCount"
              :duration="2500"
              class="card-panel-num"
            />
            <div class="card-panel-text">一般贸易商品</div>
          </div>
        </div>
      </el-col>

     
      <el-col :span="isMB?24:12" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-shopping">
            <i class="el-icon-user card-panel-icon" />
          </div>
          <div class="card-panel-description">
            <count-to
              :start-val="0"
              :end-val="data.PersonCount"
              :duration="2000"
              class="card-panel-num"
            />
            <div class="card-panel-text">注册会员</div>
          </div>
        </div>
      </el-col>
      <el-col :span="isMB?24:12" class="card-panel-col" >  <!--平台用户显示备案商品总数-->
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-shopping">
            <i class="el-icon-document card-panel-icon" />
          </div>
           <div class="card-panel-description" >
            <count-to
              :start-val="0"
              :end-val="data.OrderCount"
              :duration="2500"
              class="card-panel-num"
            />
            <div class="card-panel-text">合计订单</div>
          </div>
        </div>
      </el-col>

      
    </el-row>
  </div>
</template>

<script>
import CountTo from "vue-count-to";

export default {
  components: {
    CountTo,
  },
  data() {
    return {
      data: {
        BusinessCount: 0,
        BusinessShopCount: 0,
        PersonCount: 0,
        GoodsbondedCount: 0,
        GoodsCount: 0,
        BstrCount: 0,
        OrderCount: 0,

        CrossgoodsCount: 0,
        GeneralgoodsCount: 0,

      },
      isMB: this.$store.state.isMB
    };
  },
  methods: {
    setData(data) {
     // this.data.BusinessCount = data.BusinessCount;
     // this.data.BusinessShopCount = data.BusinessShopCount;
     
    //  this.data.GoodsbondedCount = data.GoodsbondedCount;
    //   this.data.GoodsCount = data.GoodsCount;

        this.data.PersonCount = data.PersonCount;
        this.data.OrderCount = data.OrderCount;
         this.data.CrossgoodsCount = data.CrossgoodsCount;
        this.data.GeneralgoodsCount = data.GeneralgoodsCount;
    },
    toPage(url) {
      this.$router.push(url);
    },
    toBoard() {
      // console.log(location);
      var url = location.origin + "/#/board";
      if(location.origin.indexOf("localhost") == -1) {
        url = location.origin + location.pathname + "#/board";
      }
      window.open(url)
    }
  },
};
</script>

<style lang="scss" scoped>
.title {
  .card-panel-col {
    border-bottom: solid 1px rgba(0, 0, 0, 0.03);
  }

  .card-panel {
    height: 50px;
    cursor: default;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    z-index: 1;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);

    .card-panel-description {
      float: left;
      font-weight: bold;
      margin-left: 25px;

      .card-panel-text {
        line-height: 50px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 18px;
      }
    }
  }
}

.panel-group {
  padding: 0 0 0 50px;
  @media screen and (max-width: 480px) {
    padding: 0 10px;
  }
  // .card-panel-col {
  //   margin-bottom: 45px;
  // }
  .card-panel {
    margin: 20px 0;
    height: 108px;
    cursor: default;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    @media screen and (max-width: 480px) {
      margin: 0;
    }
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #34bfa3;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f74f4f;
      }

      .icon-shopping {
        background: #4e6ab8;
      }
    }

    .icon-people {
      color: #34bfa3;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f74f4f;
    }

    .icon-shopping {
      color: #4e6ab8;
    }

    .card-panel-icon-wrapper {
      float: left;
      // margin: 14px 0 0 14px;
      padding: 16px;
      padding-right: 0;
      padding-left: 0;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 80px;
      @media screen and (max-width: 480px) {
        font-size: 68px;
      }
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      width: 48%;
      margin: 0;
      margin-top: 26px;
         margin-right: 30px;
      @media screen and (max-width: 480px) {
        margin-top: 15px;
      }
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 20px;
        margin-top: 16px;
      }

      .card-panel-num {
        font-size: 24px;
      }
    }
  }
}
.flex-title {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 50px);
    align-items: center;
}
</style>
